import { fmtEur } from "@/lib/format";
import { STAGES, partnerName, todayIso } from "./crmConst";

export const ClientsTable = ({ clients, partners, onOpen }) => (
  <div className="rounded-xl border border-border overflow-x-auto" data-testid="crm-clients-table">
    <table className="w-full text-sm">
      <thead className="bg-secondary/60 text-left text-xs uppercase tracking-wide text-muted-foreground">
        <tr>
          <th className="p-3">Société</th><th className="p-3">Contact</th><th className="p-3">Partenaire</th><th className="p-3">Étape</th>
          <th className="p-3 text-right">Projets</th><th className="p-3 text-right">Prime</th><th className="p-3">Prochaine tâche</th>
        </tr>
      </thead>
      <tbody>
        {clients.map((c) => {
          const st = STAGES.find((s) => s.v === c.stage);
          return (
            <tr key={c.id} onClick={() => onOpen(c.id)} className="border-t border-border cursor-pointer hover:bg-secondary/40 transition-colors" data-testid={`crm-row-${c.id}`}>
              <td className="p-3 font-semibold">{c.company}</td>
              <td className="p-3 text-muted-foreground">{[c.contact_name, c.email, c.phone].filter(Boolean).join(" · ") || "—"}</td>
              <td className="p-3">{partnerName(partners, c.partner_id)}</td>
              <td className="p-3"><span className="inline-flex items-center gap-1.5"><span className={`h-2 w-2 rounded-full ${st?.dot}`} />{st?.label}</span></td>
              <td className="p-3 text-right metric">{c.project_count}</td>
              <td className="p-3 text-right metric font-semibold">{fmtEur(c.total_prime)}</td>
              <td className={`p-3 text-xs ${c.next_task?.due_date < todayIso() ? "text-red-600 font-semibold" : "text-muted-foreground"}`}>
                {c.next_task ? `${c.next_task.due_date.split("-").reverse().join("/")} — ${c.next_task.title}` : "—"}
              </td>
            </tr>
          );
        })}
        {!clients.length && <tr><td colSpan={7} className="p-8 text-center text-muted-foreground" data-testid="crm-empty">Aucun client.</td></tr>}
      </tbody>
    </table>
  </div>
);
